export default "__VITE_ASSET__c7a3dd04__"